import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Cookies from "js-cookie";
import CONSTANTS from "../utils/constants";

export default function AdminBrend() {
  const navigate = useNavigate();
  const [brands, setBrands] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [userPermissions, setUserPermissions] = useState([]);

  const fetchBrands = async () => {
    setLoading(true);
    setError("");
    try {
      const response = await axios.get(`${CONSTANTS.baseRoute}/brands`);
      // Sort brands by order_number
      const sortedBrands = response.data.sort(
        (a, b) => (a.order_number || 0) - (b.order_number || 0)
      );
      setBrands(sortedBrands);
    } catch (err) {
      setError("Brendler ýüklenip bilmedi. Soňrak täzeden synanyşyň.");
      console.error("Brendler çekilirken hata:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const user = Cookies.get("user")
          ? JSON.parse(Cookies.get("user"))
          : null;
        if (!user?.id) {
          navigate("/admin");
          return;
        }

        const permissionsResponse = await axios.get(
          `${CONSTANTS.baseRoute}/permissions`,
          {
            params: { user_id: user.id },
          }
        );
        const permissions = permissionsResponse.data.permissions;
        setUserPermissions(permissions);

        if (!permissions.includes(7)) {
          setError("Bu sahypany görmek üçin rugsadyňyz ýok");
          navigate("/admin/home");
          return;
        }

        await fetchBrands();
      } catch (err) {
        setError("Maglumatlary ýüklep bolmady.");
        console.error("Error fetching data:", err);
        if (err.response?.status === 401 || err.response?.status === 403) {
          navigate("/admin");
        }
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [navigate]);

  const handleDelete = async (brandId, brandName) => {
    if (!userPermissions.includes(10)) {
      setError("Bu hereketi ýerine ýetirmek üçin rugsadyňyz ýok");
      setTimeout(() => setError(""), 3000);
      return;
    }

    if (window.confirm(`'${brandName}' atly brendi pozmak isleýärsiňizmi?`)) {
      try {
        await axios.delete(`${CONSTANTS.baseRoute}/brands/${brandId}`);
        setError("Brend üstünlikli pozuldy");
        await fetchBrands();
        setTimeout(() => setError(""), 3000);
      } catch (err) {
        setError("Brend pozulyp bilmedi");
        console.error("Brend silinirken hata:", err);
        setTimeout(() => setError(""), 3000);
      }
    }
  };

  const renderTableContent = () => {
    if (loading) {
      return (
        <tr>
          <td colSpan="6">Ýüklenýär...</td>
        </tr>
      );
    }
    if (error) {
      return (
        <tr>
          <td
            colSpan="6"
            className={`text-${
              error.includes("üstünlikli") ? "success" : "danger"
            }`}
          >
            {error}
          </td>
        </tr>
      );
    }
    if (brands.length === 0) {
      return (
        <tr>
          <td colSpan="6">Hiç hili brend tapylmady.</td>
        </tr>
      );
    }
    return brands.map((brand) => (
      <tr
        key={brand.id}
        style={{ cursor: "pointer" }}
        onClick={() =>
          userPermissions.includes(9) &&
          navigate(`/admin/home/brends/edit/${brand.id}`)
        }
      >
        <td>
          {brand.image_path ? (
            <img
              src={`${CONSTANTS.baseRoute}${brand.image_path}`}
              alt={brand.name_tm}
              style={{ width: "40px", objectFit: "contain", borderRadius: "4px" }}
            />
          ) : (
            <div
              style={{
                width: "50px",
                height: "50px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "#f8f9fa",
                borderRadius: "4px",
              }}
            >
              <i className="bi bi-image text-muted"></i>
            </div>
          )}
        </td>
        <td>{brand.order_number}</td>

        <td className="text-start">{brand.name_tm}</td>
        <td>{brand.name_en || "-"}</td>
        <td>{brand.name_ru || "-"}</td>
      </tr>
    ));
  };

  return (
    <div className="admin-main p-2">
      <div className="d-flex justify-content-between align-items-center mb-2">
        <div className="d-flex gap-2 align-items-center">
          <button className="btn admin-icon-btn" onClick={() => navigate(-1)}>
            <i className="bi bi-chevron-left"></i>
          </button>
          <button className="btn admin-icon-btn" onClick={() => navigate(+1)}>
            <i className="bi bi-chevron-right"></i>
          </button>
          <h5 className=" mb-0 fw-bold">Brend</h5>
        </div>
        {userPermissions.includes(8) && (
          <button
            data-permission-id="8"
            className="btn btn-outline-primary d-flex gap-2 align-items-center"
            onClick={() => navigate("/admin/home/brends/add")}
          >
            <i className="bi bi-plus"></i>
            <span className="d-none d-sm-inline">Täze brend goş</span>
          </button>
        )}
      </div>
      <div className="bg-light card p-2">
        <div className="d-flex mb-2">
          <input
            className=" form-control rounded-end-0"
            placeholder="Gözleg..."
            type="text"
          />
          <button className="btn bg-white rounded-start-0 border">
            <i className="bi bi-search"></i>
          </button>
        </div>
        <div className="table-responsive  ">
          <table
            className="table table-light  table-hover mb-0"
            style={{ fontSize: "14px" }}
          >
            <thead>
              <tr className="">
                <th style={{ width: "5rem" }}>Suraty</th>
                <th style={{ width: "4rem" }}>Tertibi</th>
                <th className="">Ady (TM)</th>
                <th style={{ width: "" }}>Ady (EN)</th>
                <th style={{ width: "" }}>Ady (RU)</th>
              </tr>
            </thead>
            <tbody className="">{renderTableContent()}</tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
